import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all translation files
import translationEN from './locales/en.json';
import translationES from './locales/es.json';
import translationFR from './locales/fr.json';
import translationUK from './locales/uk.json';
import translationRU from './locales/ru.json';
import translationDE from './locales/de.json';
import translationIT from './locales/it.json';
import translationNL from './locales/nl.json';
import translationPL from './locales/pl.json';
import translationPTBR from './locales/pt-BR.json';
import translationTR from './locales/tr.json';
import translationKO from './locales/ko.json';

const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
  fr: { translation: translationFR },
  uk: { translation: translationUK },
  ru: { translation: translationRU },
  de: { translation: translationDE },
  it: { translation: translationIT },
  nl: { translation: translationNL },
  pl: { translation: translationPL },
  'pt-BR': { translation: translationPTBR },
  tr: { translation: translationTR },
  ko: { translation: translationKO },
};

/** Storage key for persisted language preference */
export const LANGUAGE_STORAGE_KEY = 'studyDo_language';

/** All supported i18n language keys (use for test_data generation) */
export const I18N_LANGUAGE_KEYS = Object.keys(resources) as string[];

const storedLng = typeof window !== 'undefined' ? localStorage.getItem(LANGUAGE_STORAGE_KEY) : null;
// When localStorage has no language preference, default to English
const initialLng = storedLng && I18N_LANGUAGE_KEYS.includes(storedLng) ? storedLng : 'en';

export const i18nReady = i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLng,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
  });

export default i18n;